// Vendor imports
const classNames = require('classnames')
const React = require('react')
const PropTypes = require('prop-types')
const NukaCarousel = require('nuka-carousel').default
// Shared imports
const BemEntity = require('shared/bem')
// Convenience; in lieu of JSX transpiling...
const { createElement: tag } = React

const bem = BemEntity('FeaturedCarousel')

class CorrectlySizedNukaCarousel extends NukaCarousel {
  getSlideHeight(props, childNodes = []) {
    // Work-around a bug with slide height calculation:
    // nuka-carousel's implementation uses the `.slider-slide` height.
    // The height of the `.slider-slide` wrapper matches `.slider-list`,
    // which does not update when the height of the actual slide changes.
    const currentSliderSlideNode = childNodes[this.state.currentSlide]
    const currentActualSlideNode = currentSliderSlideNode.firstChild
    return currentActualSlideNode.offsetHeight
  }
}

class FeaturedCarousel extends React.PureComponent {
  renderDots(carouselProps) {
    const {
      currentSlide,
      goToSlide,
      slideCount,
      slidesToScroll
    } = carouselProps
    const dotIndexes = []
    for (let i = 0; i < slideCount; i += slidesToScroll) {
      dotIndexes.push(i)
    }
    return (
      tag('div', {
        className: bem.element('dots')
      },
        dotIndexes.map(index => {
          return (
            tag('button', {
              key: `FeaturedCarouselDot:${index}`,
              className: bem.element('dot', {
                active: currentSlide === index
              }),
              onClick: goToSlide.bind(null, index)
            })
          )
        })
      )
    )
  }

  renderLeftButton(carouselProps) {
    const {
      currentSlide,
      previousSlide,
      slideCount,
      wrapAround
    } = carouselProps
    const isDisabled = (currentSlide === 0 && !wrapAround) || slideCount === 0
    return (
      tag('button', {
        className: bem.element('button', {
          left: true,
          disabled: isDisabled
        }),
        disabled: isDisabled,
        onClick: previousSlide
      })
    )
  }

  renderRightButton(carouselProps) {
    const {
      currentSlide,
      nextSlide,
      slideCount,
      slidesToScroll,
      wrapAround
    } = carouselProps
    const isDisabled = currentSlide + slidesToScroll >= slideCount && !wrapAround
    return (
      tag('button', {
        className: bem.element('button', {
          right: true,
          disabled: isDisabled
        }),
        disabled: isDisabled,
        onClick: nextSlide
      })
    )
  }

  render() {
    return (
      tag('div', {
        className: classNames(
          this.props.className,
          bem.block()
        )
      },
        tag(CorrectlySizedNukaCarousel, Object.assign({
          renderBottomCenterControls: this.renderDots,
          renderCenterLeftControls: this.renderLeftButton,
          renderCenterRightControls: this.renderRightButton
        }, this.props, {
          className: bem.element('slider')
        }),
          this.props.items.map(this.props.renderSlide)
        )
      )
    )
  }
}

FeaturedCarousel.propTypes = {
  // Also passes props through to nuka-carousel
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  renderSlide: PropTypes.func.isRequired
}

FeaturedCarousel.defaultProps = {
  wrapAround: true
}

module.exports = FeaturedCarousel
